import { Component } from '@angular/core';

@Component({
  selector: 'app-hatch-defs',
  templateUrl: './hatch-defs.component.html'
})
export class HatchDefsComponent {}
